export default {
  name: 'AuthCallbackContent',
  props: {
    busy: {
      type: Boolean,
      required: true
    },
    failed: {
      type: Boolean,
      required: true
    },
    showSlow: {
      type: Boolean,
      required: true
    },
    showActions: {
      type: Boolean,
      required: true
    },
    showReload: {
      type: Boolean,
      default: true
    },
    message: {
      type: String,
      required: true
    },
    slowMessage: {
      type: String,
      required: true
    },
    tryAgainLabel: {
      type: String,
      required: true
    },
    reloadLabel: {
      type: String,
      required: true
    }
  }
};